import { useEffect, useState } from "react"

import { useTranslation } from "react-i18next"

import { ModuleLandingHero } from "@/components/layouts/module-landing-hero"

type DashGreetingProps = {
  userName?: string
}

export function DashGreeting({ userName }: DashGreetingProps) {
  const { t } = useTranslation(undefined, { keyPrefix: "dash.landing" })
  const [greeting, setGreeting] = useState<string>("")

  useEffect(() => {
    const trimmedUserName = userName?.trim()
    const greetingType = trimmedUserName ? "personalized" : "generic"

    const rawGreetings = t(`hero.greetings.${greetingType}`, { returnObjects: true })
    const greetings = Array.isArray(rawGreetings) ? rawGreetings : []

    if (greetings.length === 0) {
      setGreeting(t("hero.title"))
      return
    }

    const randomIndex = Math.floor(Math.random() * greetings.length)
    let selectedGreeting = greetings[randomIndex]

    if (trimmedUserName) {
      const firstName = trimmedUserName.split(" ")[0]
      selectedGreeting = selectedGreeting.replace("{{name}}", firstName)
    }

    setGreeting(selectedGreeting)
  }, [userName, t])

  if (!greeting) return null

  return (
    <ModuleLandingHero
      className="py-4"
      dataTestId="dash-greeting"
      greeting={greeting}
      subtitle={t("hero.subtitle")}
    />
  )
}
